/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} User_Deactivate_SuccessInputs */

const vi_user_deactivate_success = /** @type {(inputs: User_Deactivate_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đã vô hiệu hóa`)
};

/**

* @param {User_Deactivate_SuccessInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const user_deactivate_success = /** @type {((inputs?: User_Deactivate_SuccessInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<User_Deactivate_SuccessInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_user_deactivate_success(inputs)
});